export const previewScrollbar = `
    .previewScrollbar::-webkit-scrollbar {
      width: 12px;
    }
    .previewScrollbar::-webkit-scrollbar-track {
      background: #CFD8DC;
      border-radius: 8px;
    }
    .previewScrollbar::-webkit-scrollbar-thumb {
      background: #90A4AE;
      border-radius: 6px;
      border: 3px solid #CFD8DC;
    }
    .previewScrollbar::-webkit-scrollbar-thumb:hover {
      background: #90A4AE;
    }
  `;
